import { persistentAtom } from '@nanostores/persistent'
import { atom } from 'nanostores'

// Search settings that persist across sessions
export interface SearchSettings {
  collapseResults: boolean
  showMoreContext: boolean
  sortBy: 'name-asc' | 'name-desc' | 'modified-new' | 'modified-old' | 'created-new' | 'created-old'
  matchCase: boolean
}

// Explorer settings that persist across sessions
export interface ExplorerSettings {
  width: number
  isOpen: boolean
}

// Right sidebar settings that persist across sessions
export interface RightSidebarSettings {
  width: number
  isCollapsed: boolean
  userPreference: 'auto' | 'always-show' | 'always-hide'
  autoOpenOnErrors: boolean
  autoOpenOnInlineCards: boolean
  rememberClosedState: boolean
}

// Default settings
const defaultSearchSettings: SearchSettings = {
  collapseResults: false,
  showMoreContext: false,
  sortBy: 'name-asc',
  matchCase: false
}

const defaultExplorerSettings: ExplorerSettings = {
  width: 280,  // Increased default width
  isOpen: true
}

const defaultRightSidebarSettings: RightSidebarSettings = {
  width: 35,
  isCollapsed: false,
  userPreference: 'auto',
  autoOpenOnErrors: true,
  autoOpenOnInlineCards: true,
  rememberClosedState: true
}

// Create persistent stores
export const searchSettingsStore = persistentAtom<SearchSettings>(
  'searchSettings',
  defaultSearchSettings,
  {
    encode: JSON.stringify,
    decode: JSON.parse
  }
)

export const explorerSettingsStore = persistentAtom<ExplorerSettings>(
  'explorerSettings',
  defaultExplorerSettings,
  {
    encode: JSON.stringify,
    decode: JSON.parse
  }
)

export const rightSidebarSettingsStore = persistentAtom<RightSidebarSettings>(
  'rightSidebarSettings',
  defaultRightSidebarSettings,
  {
    encode: JSON.stringify,
    decode: JSON.parse
  }
)

// Helper functions
export function updateSearchSettings(updates: Partial<SearchSettings>) {
  searchSettingsStore.set({
    ...searchSettingsStore.get(),
    ...updates
  })
}

export function updateExplorerSettings(updates: Partial<ExplorerSettings>) {
  console.log('[uiSettingsStore] updateExplorerSettings called with:', updates)
  console.trace('[uiSettingsStore] updateExplorerSettings stack trace')
  explorerSettingsStore.set({
    ...explorerSettingsStore.get(),
    ...updates
  })
}

export function updateRightSidebarSettings(updates: Partial<RightSidebarSettings>) {
  rightSidebarSettingsStore.set({
    ...rightSidebarSettingsStore.get(),
    ...updates
  })
}

// Svelte store compatibility wrapper
export function createSvelteStore<T>(nanostore: any) {
  return {
    subscribe: (fn: (value: T) => void) => {
      // Call immediately with current value
      fn(nanostore.get())
      // Return unsubscribe function
      return nanostore.subscribe(fn)
    }
  }
}